import { inject, Injector, runInInjectionContext } from '@angular/core';
import { GuardResult, MaybeAsync } from '@angular/router';
import { maybeAsyncToObservable } from './maybe-async-to-observable.util';
import { iif, of, switchMap } from 'rxjs';

export const chainGuardFns = <GuardFn>(
  applyGuard: (guard: GuardFn) => MaybeAsync<GuardResult>,
  guards: GuardFn[]
): MaybeAsync<GuardResult> => {
  const injectionContext = inject(Injector);
  return guards.reduce(
    (acc, guard) =>
      maybeAsyncToObservable(acc).pipe(
        switchMap(result =>
          iif(
            () => result === true,
            runInInjectionContext(injectionContext, () => maybeAsyncToObservable(applyGuard(guard))),
            of(result)
          )
        )
      ),
    maybeAsyncToObservable(true)
  );
};
